const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckDouble(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7032 4.289C17.0959 4.67736 17.0994 5.31051 16.711 5.70319L9.78793 12.7032C9.60008 12.8931 9.34405 13 9.07692 13C8.80979 13 8.55376 12.8931 8.36592 12.7032L5.289 9.59208C4.90064 9.1994 4.90413 8.56625 5.29681 8.17789C5.68949 7.78953 6.32264 7.79302 6.711 8.1857L9.07692 10.5779L15.289 4.29681C15.6774 3.90413 16.3105 3.90064 16.7032 4.289ZM20.7071 7.29289C21.0976 7.68342 21.0976 8.31658 20.7071 8.70711L9.70711 19.7071C9.31658 20.0976 8.68342 20.0976 8.29289 19.7071L3.29289 14.7071C2.90237 14.3166 2.90237 13.6834 3.29289 13.2929C3.68342 12.9024 4.31658 12.9024 4.70711 13.2929L9 17.5858L19.2929 7.29289C19.6834 6.90237 20.3166 6.90237 20.7071 7.29289Z",
    fill: "#1859FF",
    style: {
      fill: "#1859FF",
      fill: "color(display-p3 0.0941 0.3490 1.0000)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckDouble);
export default __webpack_public_path__ + "static/media/icon-check-double.20c63f3eff698da7484b82f571f14016.svg";
export { ForwardRef as ReactComponent };